export default __webpack_public_path__ + "static/media/SvenBeckert.9fc6d5e2.png";